import { Flex, Image, Button } from "@chakra-ui/react";
import { H3, BodyText2 } from "src/atoms/typography";
import Modal from "src/components/Modal";

export default function VerticalDialog({
  isOpen,
  heading,
  text,
  imageSrc,
  imageWidth = "137px",
  buttonTop,
  buttonBottom,
  zIndex
}) {
  return (
    <Modal isOpen={isOpen} zIndex={zIndex}>
      <Flex
        width="280px"
        pt="24px"
        pb="8px"
        px="32px"
        flexDirection="column"
        alignItems="center"
      >
        {imageSrc && <Image src={imageSrc} width={imageWidth} />}
        <H3 mt={imageSrc ? "16px" : 0} color="highEmphasis" textAlign="center">
          {heading}
        </H3>
        <BodyText2 mt="8px" color="mediumEmphasis" textAlign="center">
          {text}
        </BodyText2>
        {buttonTop && (
          <Button
            variant="containedPrimary"
            minWidth="158px"
            mt="24px"
            onClick={buttonTop.onClick}
          >
            {buttonTop.text}
          </Button>
        )}
        {buttonBottom && (
          <Button
            variant="flatPrimary"
            minWidth="158px"
            mt="8px"
            onClick={buttonBottom.onClick}
          >
            {buttonBottom.text}
          </Button>
        )}
      </Flex>
    </Modal>
  );
}
